export const validatePostcode = postcode => {
  try {
    // TODO: Replace hardcoded regex with UK_POSTCODE_REGEX from app/javascript/constants
    const format = postcode
      .toUpperCase()
      .match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
    const finalValue = `${format[1]} ${format[2]}`;
    const regex =
      /^([a-z]{1,2}[0-9]{1,2}|[a-z]{1,2}[0-9][a-z]) ?\d[ABD-HJLNP-UW-Z]{2}$/i;

    return {
      isValid: regex.test(postcode),
      formatedPostCode: finalValue,
      error: false,
      info: 'It is a valid postcode',
    };
  } catch (error) {
    return { error: true, info: 'Invalid post code has been entered!' };
  }
};

export const validateAddress = address =>
  address.name !== '' &&
  address.line_1 !== '' &&
  address.line_3 !== '' &&
  validatePostcode(address.postcode).isValid;
